module.exports = __webpack_public_path__ + "assets/img/00127.a6ef5079.png";